module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Regular.0bb068d0.ttf";